import { Component, inject } from '@angular/core';
import { I18nService } from '../../services/i18n.service';
@Component({
  selector: 'app-us-privacy-rights',
  imports: [],
  templateUrl: './us-privacy-rights.html',
  styleUrl: './us-privacy-rights.scss',
})
export class UsPrivacyRightsComponent {
  public i18n = inject(I18nService);
}
